import { SessionVideoOptions } from './session-video-options';

export class SessionWebinar {
  public eventId?: number;
  public eventDisabled?: boolean;
  public sessionVideoOptions?: SessionVideoOptions;
}
